export default class XhrForm {
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...XhrForm.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.DOM.$errors = this.DOM.$el.querySelector(this.options.selectorErrors)
        this.DOM.$autosave = this.DOM.$el.querySelector(this.options.selectorAutosave)
        this.DOM.$status = this.DOM.$el.querySelector(this.options.selectorStatus)
        this.DOM.$autosaveDiv = this.DOM.$el.querySelector(this.options.selectorAutosaveNotification)
        // TODO: we should have 2 different levels of status, right now if the form has a status inside,
        // for instance on the panel, the status on the list will be ignored, but we need to use it to comunicate
        // the success after saving, and we should also keep the status inside the form to show error messages
        if (!this.DOM.$status) {
            this.DOM.$status = document.querySelector(this.options.selectorStatus)
        }

        this.headers = {
            'Accept': 'application/json',
            'Cache-Control': 'no-cache',
            'X-CSRF-TOKEN': document.querySelector('meta[name="_token"]').getAttribute('content'),
            ...this.options.headers,
        }
        this.method = this.DOM.$el.getAttribute('method')
        this.url = this.DOM.$el.getAttribute('action')
        // Default value to avoid errors on autosave
        this.$submitter = document.createElement('button')

        this.DOM.$el.addEventListener('submit', this.onSubmit.bind(this))
        if (this.DOM.$autosave) {
            this.$hasChanges = false
            this.DOM.$autosave.addEventListener('change', this.onAutosaveChange.bind(this))
            this.DOM.$el.addEventListener('xhrForm:autosave', this.onSubmit.bind(this))
            this.onAutosaveChange()
        }
    }

    displayErrors(errors) {
        let $error
        let $field
        let $fieldError
        let $fieldErrors
        let $input
        let name

        for (const key in errors) {
            name = key.split('.').reduce((accumulator, currentValue, currentIndex) => {
                return accumulator +
                    (currentIndex === 0
                        ? currentValue
                        : '[' + currentValue + ']'
                    )
            }, '')
            $input = this.DOM.$el.querySelector(`[name="${name}"]`)

            if (!$input) {
                $input = this.DOM.$el.querySelector(`[name="${name}[]"]`)
            }

            if ($input) {
                $field = $input.closest(this.options.selectorField)

                if ($field) {
                    $field.classList.add(this.options.classNameHasError)
                    $fieldErrors = $field.querySelector(this.options.selectorFieldErrors)

                    if ($fieldErrors) {
                        errors[key].forEach(error => {
                            $fieldError = document.createElement('li')
                            $fieldError.innerHTML = error
                            $fieldErrors.appendChild($fieldError)
                        })
                    }
                }
            }

            if (this.DOM.$errors) {
                errors[key].forEach(error => {
                    this.displayError(error)
                })
            }
        }

        if (this.DOM.$errors) {
            // Scroll into the general error view
            this.DOM.$errors.scrollIntoView({ behavior: 'smooth', block: 'center' })
            this.DOM.$errors.dispatchEvent(new CustomEvent('element:should-be-visible', { bubbles: true }))
        } else if ($field) {
            $field.dispatchEvent(new CustomEvent('element:should-be-visible', { bubbles: true }))
            // Scroll into the last field with errors
            $field.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }

    }

    displayError(error) {
        let $error

        if (this.DOM.$errors) {
            $error = document.createElement('li')
            $error.innerHTML = error
            this.DOM.$errors.appendChild($error)
            this.DOM.$errors.classList.remove('u-hide')
        }
    }

    onSubmit(e) {
        e.preventDefault()

        let { headers, method, url } = this

        if (e.submitter) {
            this.$submitter = e.submitter

            // Change action if needed
            if (this.$submitter.dataset[this.options.dataAttrFormAction]) {
                url = this.$submitter.formAction
            }
        }


        url = url.trim()

        const data = new FormData(this.DOM.$el)
        if (e.detail && e.detail.autosave) {
            data.append('autosave', true)
        }

        if (this.DOM.$el.dataset[this.options.dataAttrConfirm]) {
            if (!window.confirm(this.DOM.$el.dataset[this.options.dataAttrConfirm])) {
                return false
            }
        }

        this.DOM.$el.classList.add(this.options.classNameIsBusy)
        this.$submitter.classList.add(this.options.classNameIsBusy)

        if (this.DOM.$autosaveDiv) {
            this.DOM.$autosaveDiv.classList.add(this.options.classNameIsBusy)
        }
        this.DOM.$el.dispatchEvent(new CustomEvent('xhrform:beforesend'))
        var requestUrl = url
        axios({ data, headers, method, url })
            .then(response => {
                this.reset()

                this.DOM.$el.classList.add(this.options.classNameIsSuccess)
                this.DOM.$el.classList.remove(this.options.classNameIsBusy)
                this.$submitter.classList.remove(this.options.classNameIsBusy)
                // This timeout allows the autosave notification to show for long enough for the user to actually read it...
                if (this.DOM.$autosaveDiv) {
                    setTimeout(() => {
                        this.DOM.$autosaveDiv.classList.remove(this.options.classNameIsBusy)
                    }, 1000)
                }
                this.DOM.$el.dispatchEvent(new CustomEvent('xhrform:complete', { detail: response.data }))
                this.DOM.$el.dispatchEvent(new CustomEvent('xhrform:success', { detail: response.data }))

                if (response.request.responseURL !== requestUrl) {
                    this.DOM.$el.dispatchEvent(new CustomEvent('xhrform:beforeredirect', { detail: response.request.responseURL }))
                    window.location = response.request.responseURL
                }

                if (response.data.feedback) {

                    if(!this.DOM.$el.dataset[this.options.dataAttrAvoidFeedbackNotification]) {
                        let feedback_type = response.data.feedback.notificationType ? response.data.feedback.notificationType : "main"
                        document.dispatchEvent(new CustomEvent('feedback:show', { detail: { type: feedback_type, feedback: response.data.feedback, status: this.DOM.$status, is_panel: this.DOM.$el.dataset[this.options.dataAttrIsPanel] } }))
                    }

                    if (response.data.feedback.reloadComponent) {
                        let ComponentId = this.DOM.$el.dataset[this.options.dataAttrComponentToReloadId]
                        if (response.data.feedback.reloadComponentData) {
                            let $componentToReload = document.querySelector('#' + ComponentId)
                            $componentToReload.innerHTML = response.data.feedback.reloadComponentData
                        } else {
                            let ComponentRoute = this.DOM.$el.dataset[this.options.dataAttrComponentToReloadRoute]
                            let reloadComponentEvent = this.DOM.$el.dataset[this.options.dataAttrReloadComponentEvent]

                            axios({ method: 'get', url: ComponentRoute })
                                .then(response => {
                                    document.querySelector('#' + ComponentId).innerHTML = response.data
                                })
                                .then(response => {
                                    if (reloadComponentEvent) {
                                        document.body.dispatchEvent(new CustomEvent(reloadComponentEvent))
                                    }
                                })
                        }
                    }

                    if (response.data.feedback.redirect) {
                        window.location.href = response.data.feedback.redirect
                    }

                    if (response.data.feedback.reload) {
                        window.location.reload()
                    }

                    if (response.data.feedback.modalRedirect) {
                        this.DOM.$el.dispatchEvent(new CustomEvent('modal:redirect', {
                            detail: {
                                url: response.data.feedback.modalRedirect,
                                size: response.data.feedback.modalRedirectSize,
                            }
                        }))
                    }

                    if (response.data.feedback && response.data.feedback.closePanel) {
                        let $detail = { feedback_type: response.data.feedback.type }

                        if (response.data.feedback.closeOverlay) {
                            $detail = {
                                ...$detail,
                                'overlay': response.data.feedback.closeOverlay
                            }
                        }
                        this.DOM.$el.dispatchEvent(new CustomEvent('close:close', { detail: $detail }))
                    } else {
                        if (response.data.feedback && response.data.feedback.autosaveChangeActionAfterSave) {
                            this.DOM.$el.action = response.data.feedback.autosaveChangeActionAfterSave
                            this.url = this.DOM.$el.action
                        }
                    }
                }

                this.DOM.$el.dispatchEvent(new CustomEvent('modal:close'))
            })
            .catch(error => {
                let response = {
                    status: 500,
                    data: {
                        feedback: {
                            type: 'error',
                            title: '',
                            message: 'Error',
                        }
                    },
                    ...error.response
                }

                this.reset()

                this.DOM.$el.classList.remove(this.options.classNameIsBusy)
                this.$submitter.classList.remove(this.options.classNameIsBusy)

                // This timeout allows the autosave notification to show for long enough for the user to actually read it...
                if (this.DOM.$autosaveDiv) {
                    setTimeout(() => {
                        this.DOM.$autosaveDiv.classList.remove(this.options.classNameIsBusy)
                    }, 1000)
                }
                this.DOM.$el.dispatchEvent(new CustomEvent('xhrform:complete', { detail: response.data }))

                switch (response.status) {
                    case 302:
                        if (response.data.hasOwnProperty('location')) {
                            this.DOM.$el.dispatchEvent(new CustomEvent('xhrform:beforeredirect', { detail: response.data }))
                            window.location = response.data.location
                        }
                        break

                    case 422:
                        this.DOM.$el.classList.add(this.options.classNameHasErrors)
                        this.DOM.$el.dispatchEvent(new CustomEvent('xhrform:validationerror'))

                        if (response.data.result === 'error') {
                            this.displayError(response.data.message)
                            if (this.DOM.$errors) {
                                // Scroll into the general error view
                                this.DOM.$errors.scrollIntoView({ behavior: 'smooth' })
                            }
                        } else {
                            this.displayErrors(response.data.errors)
                        }


                        if (response.data.feedback) {
                            let feedback_type = response.data.feedback.notificationType ? response.data.feedback.notificationType : "main"
                            document.dispatchEvent(
                                new CustomEvent("feedback:show", {
                                    detail: { type: feedback_type, feedback: response.data.feedback, is_panel: this.DOM.$el.dataset[this.options.dataAttrIsPanel] },
                                })
                            )
                        } else {
                            document.dispatchEvent(
                                new CustomEvent("feedback:show", {
                                    detail: { type: "main", feedback: { type: "error" }, is_panel: this.DOM.$el.dataset[this.options.dataAttrIsPanel] },
                                })
                            )
                        }

                        break

                    default:
                        this.DOM.$el.classList.add(this.options.classNameHasServerError)
                        this.DOM.$el.dispatchEvent(new CustomEvent('xhrform:servererror'))

                        if (response.data.feedback) {
                            let feedback_type = response.data.feedback.notificationType ? response.data.feedback.notificationType : "main"
                            document.dispatchEvent(
                                new CustomEvent("feedback:show", {
                                    detail: { type: feedback_type, feedback: response.data.feedback, is_panel: this.DOM.$el.dataset[this.options.dataAttrIsPanel] },
                                })
                            )
                        } else {
                            document.dispatchEvent(
                                new CustomEvent("feedback:show", {
                                    detail: { type: "main", feedback: { type: "error" }, is_panel: this.DOM.$el.dataset[this.options.dataAttrIsPanel] },
                                })
                            )
                        }

                        break
                }

                if (response.data.feedback) {
                    // TODO: this is the case when there is a server error that should be shown inside the panel
                    // for now we don't have that kind of status components that used to be in livewire
                    document.dispatchEvent(new CustomEvent('feedback:show', { detail: { type: 'status', status: this.DOM.$status, feedback: response.data.feedback, is_panel: this.DOM.$el.dataset[this.options.dataAttrIsPanel] } }))
                }
            })

        this.DOM.$el.dispatchEvent(new CustomEvent('xhrform:send', { detail: data }))
    }

    reset() {
        this.DOM.$el.classList.remove(this.options.classNameHasErrors, this.options.classNameIsSuccess)

        for (const $el of this.DOM.$el.getElementsByClassName(this.options.classNameHasError)) {
            $el.classList.remove(this.options.classNameHasError)
        }

        for (const $el of this.DOM.$el.querySelectorAll(this.options.selectorFieldErrors)) {
            $el.innerHTML = ''
        }

        if (this.DOM.$errors) {
            this.DOM.$errors.innerHTML = ''
        }
    }

    onAutosaveChange() {
        this.$autosaveDelay = this.DOM.$autosave.dataset.xhrFormAutosaveDelay ? this.DOM.$autosave.dataset.xhrFormAutosaveDelay : 10000
        if (this.DOM.$autosave.checked) {
            var self = this;

            [...this.DOM.$el.elements].forEach(($input) => {
                $input.addEventListener('change', () => {
                    self.$hasChanges = true
                })
            })

            this.$autosaveInterval = window.setInterval(() => {
                if (self.$hasChanges) {
                    self.DOM.$el.dispatchEvent(new CustomEvent('xhrForm:autosave', { detail: { autosave: true } }))
                    self.$hasChanges = false
                }
            }, this.$autosaveDelay)
        } else {
            clearInterval(this.$autosaveInterval)
        }
    }
}

XhrForm.prototype.defaults = {
    dataAttrConfirm: 'xhrFormConfirm',
    dataAttrComponentToReloadId: 'xhrFormComponentToReloadId',
    dataAttrComponentToReloadRoute: 'xhrFormComponentToReloadRoute',
    dataAttrTriggerEvent: 'xhrFormTriggerEvent',
    dataAttrFeedbackEvent: 'xhrFormFeedbackEvent',
    dataAttrFeedbackNotification: 'xhrFormFeedbackNotification',
    dataAttrFormAction: 'xhrFormSubmitFormAction',
    dataAttrReloadComponentEvent: 'xhrFormReloadComponentEvent',
    dataAttrIsPanel: 'xhrFormIsPanel',
    classNameIsBusy: 'is-busy',
    classNameHasError: 'has-error',
    classNameHasErrors: 'has-errors',
    classNameHasServerError: 'has-serverError',
    classNameIsSuccess: 'is-success',
    headers: {},
    selectorStatus: '.js-xhrFormStatus',
    selectorErrors: '.js-xhrFormErrors',
    selectorField: '.js-xhrFormField',
    selectorFieldErrors: '.js-xhrFormFieldError',
    selectorAutosave: '.js-xhrFormAutosaveSwitch',
    selectorAutosaveNotification: '.js-xhrFormAutosaveNotification',
}
